import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginForm from './components/LoginForm';
import Header from './components/Header'; // ✅ Add this
import Footer from './components/Footer';
import Home from './pages/Home';
import Agents from './pages/Agents';
import About from './pages/About';
import Ydelser from './pages/Ydelser';
import Kundecases, { CaseDetail } from './pages/Kundecases';
import Udbudsagent from './pages/Udbudsagent';
import Emailagenten from './pages/Emailagenten';
// import PLCAgent from './pages/PLCAgent';
import EmailAgent from './pages/EmailAgent';
import AIInsigter, { AIInsigtDetail } from './pages/AIInsigter';
import Losninger from './pages/Losninger';
import AIKursus from './pages/AIKursus';
import AIDiscovery from './pages/AIDiscovery';
import AICenterOfExcellence from './pages/AICenterOfExcellence';
import AIDag from './pages/AIDag';
import AICEInternal from './pages/AICEInternal';
import AssistentDokumentation from './pages/aice/AssistentDokumentation';
import RasmusKaltoft from './pages/RasmusKaltoft';

// Read the non-httpOnly signal cookie set by the server on login
const isAuthenticated = () =>
  document.cookie.split(';').some((c) => c.trim().startsWith('aice_session='));

const ProtectedRoute = ({ element }) => {
  return isAuthenticated() ? element : <Navigate to="/login" replace />;
};

function App() {
  // Debug: log imported component types to help diagnose "Element type is invalid" errors
  // Remove or comment out after debugging
  // eslint-disable-next-line no-console
  console.log('DEBUG imports:', {
    HeaderType: typeof Header,
    HeaderName: Header && Header.name,
  });
  const [, setUser] = useState(null);

  const handleLoginSuccess = (data) => {
    setUser({ username: data.username });
  };

  return (
    <Router>
      <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
        {/* Always visible */}
        <Header />

        {/* Page routes */}
        <main style={{ flex: 1 }}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<LoginForm onLoginSuccess={handleLoginSuccess} />} />
            <Route path="/agents" element={<ProtectedRoute element={<Agents />} />} />
            <Route path="/agents/email" element={<ProtectedRoute element={<EmailAgent />} />} />
            <Route path="/kundecases" element={<Kundecases />} />
            <Route path="/kundecases/:caseId" element={<CaseDetail />} />
            <Route path="/about" element={<About />} />
            <Route path="/ydelser" element={<Ydelser />} />
            <Route path="/ydelser/ai-kursus" element={<AIKursus />} />
            <Route path="/ydelser/ai-discovery" element={<AIDiscovery />} />
            <Route path="/ydelser/ai-center-of-excellence" element={<AICenterOfExcellence />} />
            <Route path="/losninger" element={<Losninger />} />
            <Route path="/losninger/udbudsagent" element={<Udbudsagent />} />
            <Route path="/losninger/emailagenten" element={<Emailagenten />} />
            {/*
            <Route path="/losninger/plc-agent" element={<PLCAgent />} />
            */}
            <Route path="/ai-insigter" element={<AIInsigter />} />
            <Route path="/ai-insigter/:slug" element={<AIInsigtDetail />} />
            <Route path="/ai-dag" element={<AIDag />} />
            <Route path="/rasmus-kaltoft" element={<RasmusKaltoft />} />
            <Route path="/aice" element={<ProtectedRoute element={<AICEInternal />} />} />
            <Route path="/aice/assistenter" element={<ProtectedRoute element={<AssistentDokumentation />} />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>

        <Footer />
      </div>
    </Router>
  );
}

export default App;
